const vars = {
  root: "/",
  design: "/design/",
  the_host: "www.biwako-visitors.jp",
  api: {
    web_register: '/api/devices/web_register',
  },
  // アプリ名としては長すぎるので
  // サイクリングは表示させない
  // pwa_name: "ビワイチ サイクリング",
  pwa_name: "滋賀観光",
  pwa_js: "/service-worker.js",
  pwa_keys: {
    develop: "BGNEL15yGxjEJAU4+LgsdtyyIVd9w+15qNI6ZjjpYIsoxeJxJEUIh0gzXi3xyp6LXd2Z9/ZQEAIiIr0ttF6rvzc=",
    production: "BNkrDMxndZ6nh3IL2rsC1ocseB3s2TQeVwT1gEkMoH9jfHrLaZELmYgmNtOkR4QDp5MODH/r22pML+fpD+SRMR4=",
  },
  pwa_icons: {
    sm: "/design/img/pwa/48.png",
    md: "/design/img/pwa/192.png",
    lg: "/design/img/pwa/1024.png",
  },
}

export default vars



// WEBPACK FOOTER //
// ./_src/js/pwa/vars.js